import { useEffect, useState } from "react";
import { apiClient } from "../../lib/api";

const OPTS = [
  { v: "yes", ar: "متوفر", en: "Yes" },
  { v: "no", ar: "غير متوفر", en: "No" },
  { v: "unknown", ar: "لا أعرف", en: "Unknown" },
];

export const SpecChecklist = ({ value, onChange, lang }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    apiClient.get("/spec-library/car").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  const ar = lang === "ar";
  const specs = value || {};
  const pick = (k, v) => onChange({ ...specs, [k]: v });
  return (
    <div className="surface rounded-2xl p-4" dir={ar ? "rtl" : "ltr"} data-testid="spec-checklist">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex justify-between items-center text-sm font-semibold" data-testid="spec-checklist-toggle">
        <span>{ar ? "التجهيزات (اختياري)" : "Equipment (optional)"}</span>
        <span className="text-xs text-[#8a6f2e]">{open ? (ar ? "إخفاء" : "Hide") : (ar ? "إضافة" : "Add")}</span>
      </button>
      {open && (
        <div className="mt-3 space-y-2">
          {items.map((s) => {
            const cur = specs[s.key] || "unknown";
            return (
              <div key={s.key} className="flex flex-wrap items-center justify-between gap-2" data-testid={`spec-row-${s.key}`}>
                <span className="text-sm">{ar ? s.name_ar : s.name_en}</span>
                <div className="flex gap-1">
                  {OPTS.map((o) => (
                    <button key={o.v} type="button" onClick={() => pick(s.key, o.v)}
                      className={`px-3 py-1 rounded-full text-xs border ${cur === o.v ? "bg-[#c9a55c] text-white border-[#c9a55c]" : "border-[#d9d9d9]"}`}
                      data-testid={`spec-${s.key}-${o.v}`}>
                      {ar ? o.ar : o.en}
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
